import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const giftCardUsedApi = createAsyncThunk(
  "giftCardUsed",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/giftcardc2c", { params });
    return response.data;
  }
);

const giftCardUsedSlice = createSlice({
  name: "giftCardUsed",
  initialState: {
    giftCardUsed: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(giftCardUsedApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(giftCardUsedApi.fulfilled, (state, action) => {
        state.giftCardUsed = action.payload;
        state.loading = false;
      })
      .addCase(giftCardUsedApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});
export default giftCardUsedSlice.reducer;
